import { useState, useMemo } from "react";

// Helper function to get nested property value
const getNestedValue = (obj, path) => {
  if (!path) return undefined; // Handle null/undefined path
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};

const useSortedData = (data, initialSortKey = null, initialDirection = "descending") => {
  const [sortConfig, setSortConfig] = useState({
    key: initialSortKey,
    direction: initialDirection,
  });

  const sortedData = useMemo(() => {
    if (!sortConfig.key || !data) return data || [];

    const sortedArray = [...data].sort((a, b) => {
      const valueA = getNestedValue(a, sortConfig.key);
      const valueB = getNestedValue(b, sortConfig.key);

      if (valueA == null && valueB == null) return 0;
      if (valueA == null) return sortConfig.direction === "ascending" ? -1 : 1;
      if (valueB == null) return sortConfig.direction === "ascending" ? 1 : -1;

      if (valueA < valueB) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (valueA > valueB) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });

    return sortedArray;
  }, [data, sortConfig]);

  const requestSort = (key) => {
    let direction = "descending";
    if (
      sortConfig.key === key &&
      sortConfig.direction === "descending"
    ) {
      direction = "ascending";
    }
    setSortConfig({ key, direction });
  };

  return { sortedData, requestSort, sortConfig };
};

export default useSortedData;
